import { styled, useTheme } from "@mui/material/styles"
import MuiDrawer from "@mui/material/Drawer"
import Divider from "@mui/material/Divider"
import { List, useMediaQuery } from "@mui/material"
import ListMain from "./ListMain/ListMain"
import { useAppSelector } from "../../../store/app/hooks"
import { selectMenuStatus } from "../../../store/features/menu/menuSlice"
import DrawerHeader from "./DrawerHeader/DrawerHeader"

const drawerWidth: number = 290

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    backgroundColor: "#5D490E",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
      [theme.breakpoints.down("md")]: {
        width: 0,
      },
    }),
  },
  "& .MuiList-root": {
    maxHeight: "94vh",
    overflowY: "auto",
    overflowX: "hidden",
  },
}))

export default function DrawerBar() {
  const open = useAppSelector(selectMenuStatus)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  return (
    <Drawer
      variant={(isMobile && open) || !isMobile ? "permanent" : "persistent"}
      sx={isMobile ? { position: "absolute", top: "50px" } : {}}
      open={open}
    >
      {!isMobile && <DrawerHeader />}
      <Divider />
      <List component="nav">
        <ListMain />
      </List>
    </Drawer>
  )
}
